export const useCalendlyUrl = () => {
  const { user, displayName, isAuthenticated } = useUser()
  const baseUrl = "https://calendly.com/bella-shraier-finqai/finq-call"

  const calendlyUrl = computed(() => {
    if (!isAuthenticated.value) return baseUrl

    const queryParams = new URLSearchParams({
      name: displayName.value ?? "",
      email: user.value?.email ?? "",
      salesforce_uuid: user.value?.id ?? "",
    })

    return `${baseUrl}?${queryParams.toString()}`
  })

  return { calendlyUrl }
}
